import React, {Component} from 'react'
import {Editor} from "react-draft-wysiwyg";
import {Button} from "react-bootstrap";
import {ContentState, convertFromHTML, convertToRaw, EditorState} from "draft-js";
import Select from 'react-select'
import draftToHtml from "draftjs-to-html";
import AdminService from "../AdminService";

export default class EdytujStrone extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aktywny: false,
            kategoria: '',
            kategorie: [],
            strona: [],
            tytul: '',
            redirect: false,
            tresc: EditorState.createEmpty()
        };

        this.handleTytulChange = this.handleTytulChange.bind(this);
        this.handleTrescChange = this.handleTrescChange.bind(this);
        this.handleKategoria = this.handleKategoria.bind(this);
        this.handleUrl = this.handleUrl.bind(this)
    }

    componentWillMount() {
        AdminService.getKategorie()
            .then(function (response) {
                for (let i = 0; i < response.data.content.length; i++) {
                    this.setState(prevState => ({
                        kategorie: [...prevState.kategorie, {
                            value: response.data.content[i].id,
                            label: response.data.content[i].nazwa
                        }]
                    }))
                }
                AdminService.getStronaById(this.props.itemId)
                    .then(function (response) {
                        let tresc = EditorState.createEmpty();
                        let redirect = false;
                        if (response.data.tresc !== null && response.data.tresc !== '' && response.data.tresc !== 8 && response.data.tresc.substr(0, 1) !== '/') {

                            const blocksFromHTML = convertFromHTML(
                                response.data.tresc
                            );

                            const content = ContentState.createFromBlockArray(
                                blocksFromHTML.contentBlocks,
                                blocksFromHTML.entityMap
                            );

                            tresc = EditorState.createWithContent(content);
                        }
                        if (response.data.tresc.substr(0, 1) === '/') {
                            tresc = response.data.tresc;
                            redirect = true
                        }
                        this.setState({
                            loading: false,
                            redirect: redirect,
                            aktywny: response.data.aktywny,
                            tytul: response.data.tytul,
                            tresc: tresc,
                            kategoria: {value: response.data.kategoria.id, label: response.data.kategoria.nazwa}
                        })

                    }.bind(this)).catch(err => {
                    console.log(err)
                })
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            tresc: editorState,
        });
    };

    handleUrl(e) {
        this.setState({tresc: e.target.value})
    }

    handleTytulChange(e) {
        this.setState({tytul: e.target.value})
    }

    handleTrescChange(e) {
        this.setState({tresc: e.target.value})
    }

    handleKategoria(e) {
        this.setState({kategoria: e})
    }

    uploadPutStrona() {
        let tresc;
        if (this.state.redirect) {
            tresc = this.state.tresc
        } else {
            tresc = draftToHtml(convertToRaw(this.state.tresc.getCurrentContent()))
        }
        AdminService.putStrona(this.props.itemId, "PAGE", this.state.tytul, tresc, this.state.aktywny, {
            id: this.state.kategoria.value,
            nazwa: this.state.kategoria.label
        })
            .then(function (response) {
                this.props.goZarzadzanie()
            }.bind(this))
    }

    render() {
        return <div className="aktualnosciTabContainer">
            <div className="aktualnosciOpis">
                Aby edytować stronę należy zmienić wybrane do zmiany pola. Stronę można później edytować ponownie
                przez zakładkę
                <span style={{cursor: 'pointer'}} onClick={() => this.props.goZarzadzanie()}>
                    <b> zarządzanie</b>
                </span>.
            </div>
            <div className="nowyWpisForm">
                {this.state.kategoria.label === 'Elementy witryny' ? null : <div className="field">Tytuł:
                    <input type="text" value={this.state.tytul} maxLength={100} onChange={this.handleTytulChange}
                           disabled={this.state.kategoria.label === 'Elementy witryny'}
                           className="form-control"/></div>}
                {this.state.kategoria.label === 'Elementy witryny' ? null : <div className="field">
                    <input type="checkbox" checked={!this.state.redirect}
                           onChange={() => this.setState({redirect: false, tresc: EditorState.createEmpty()})}/> Treść
                    <input type="checkbox" checked={this.state.redirect}
                           onChange={() => this.setState({redirect: true, tresc: ''})}
                           style={{marginLeft: 15}}/> Przekierowanie
                </div>}
                <div className="field">{this.state.redirect ? 'Adres linku:' : 'Treść:'}
                    {this.state.redirect ?
                        <input type="text" value={this.state.tresc} className="form-control"
                               placeholder={'Podaj adres linku zaczynając od http://...'}
                               onChange={(e) => this.setState({tresc: e.target.value})}/>
                        : <Editor
                            editorState={this.state.tresc}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperEditor"
                            editorClassName="editorEditor"
                            onEditorStateChange={this.onEditorStateChange}
                        />}</div>
                {this.state.kategoria.label === 'Elementy witryny' ? null : <div className="field">Dodaj do folderu:
                    <Select
                        options={this.state.kategorie}
                        value={this.state.kategoria}
                        onChange={this.handleKategoria}
                        clearable={false}
                        placeholder={'Wybierz kategorię...'}
                    /></div>}
                {this.state.kategoria.label === 'Elementy witryny' ? null : <div className="field">Pokaż na stronie:
                    <input type={'checkbox'} checked={this.state.aktywny} onClick={()=>this.setState({aktywny: !this.state.aktywny})} style={{marginLeft: 10}}/></div>}
                <hr/>
                <div className="text-right">
                    <Button bsStyle={'success'} onClick={() => this.uploadPutStrona()}>Aktualizuj wpis</Button>
                </div>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/stronyComponents/EdytujStrone.js